/** Merchant language for source-linked candidates, not promised remedies or automatically authored tests. */
export const nextTestsCopy = {
    heading: 'Ideas for your next test',
    createDraft: 'Create editable draft',
    openDraft: 'Open editable draft',
    createFailed: 'The draft could not be created. Try again.',
    draftNote: 'Review the idea and supply the actual alternative in the draft. Creating it does not prepare or run a test.',
    draftHeading: 'Idea behind this draft',
    draftFixed: 'Keep unchanged',
    draftAlternatives: 'Suggested alternatives — confirm before use',
    draftDecisions: 'Your decisions',
    draftReview: 'These are the original suggestions. Your edited comparison still needs review before you submit it.',
    sourceResults: 'View source results',
    note: 'These are ideas drawn from simulated shopper answers, not proven improvements or observed sales. Confirm the details before creating another test.',
    scopeHeading: 'Answers used',
    scope: (saved, planned) => `${saved} complete saved conversations from ${planned} planned shoppers. Original and follow-up answers belong to the same shopper.`,
    supporting: 'Supporting answer',
    qualifying: 'Qualification or counterexample',
    followupQuestion: 'Follow-up question',
    page: (page, count) => `Idea ${page} of ${count}`,
    previous: 'Previous idea',
    next: 'Next idea',
    evidence: 'Read answers',
    explore: 'Review comparison and supporting answers',
    otherAnswers: 'Other answers',
    explicitRequest: 'The proposed change was explicitly requested in the cited answer.',
    hypothesis: 'The proposed change is an analysis hypothesis, not a request or a proven remedy.',
    change: 'Change to compare',
    alternatives: 'Alternatives',
    fixed: 'Keep fixed',
    learn: 'What to learn',
    qualifications: 'Limits and counterexamples',
    decisions: 'You still need to decide',
    candidates: 'Candidate comparisons',
    empty: 'Analysis finished without a supported next-test idea in these answers. Your scores and original answers are unchanged.',
    incomplete: 'Next-test analysis is incomplete. Only successfully saved ideas are shown. Each group was read separately, so these are not a combined conclusion about all answers.',
    separate: 'Each group was read separately. Similar ideas may appear more than once; their order does not rank importance or predict a winner.',
    stopped: 'Next-test analysis stopped before all results were saved. Your scores and original answers are still available. The saved attempt needs review before analysis continues.',
    failed: 'The saved next-test analysis could not be read. Your scores and original answers are still available.',
};
//# sourceMappingURL=study-next-tests.js.map